import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Icon } from 'react-icons-kit';
import { fileText } from 'react-icons-kit/feather/fileText';

import style from '../../pages/DashBoard/ExternalDash/IssueType.module.css'

import API from "../../ApiConfig"
import cogoToast from 'cogo-toast-react-17-fix';

import { androidArrowBack } from 'react-icons-kit/ionicons/androidArrowBack';
import ReactPortalModal from '../../components/ReactPortalModal';
import ShimmerLoader from '../../components/ShimmerLoader';
import { DOCUMENT_PREVIEW, VALIDATE_SECURE_QR } from '../../Utils/constant';
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper';
import { formatText } from '../../Utils/helper';
import AnimatedLoader from '../../components/AnimationLoader';

const VERIFICATION_RESULT_STORAGE_KEY = 'verification_result';

const QryptalData = () => {
  const {issued_uuid}=useParams()
        const [loading, setLoading]=useState(false)
        const [documentDetails, setDocumentDetails]=useState({
          "issuer_name": "",
          "candidate_name": "",
          "issued_uuid": null,
          "document_name": "Verified Document",
          "doc_data": {}
      })
        const [pdfLoading, setPDFloading]=useState(null)
    
        const [loadingText, setLoadingText]=useState("")
        const [preview, setPreview] = useState(null)
        const navigate=useNavigate()

        const hydrateFromValidationResponse = (responseData = {}) => {
          setDocumentDetails((prev) => ({
            ...prev,
            issuer_name: responseData.issuer_company_name || prev.issuer_name,
            candidate_name: responseData.candidate_name || responseData.doc_fields?.name || prev.candidate_name,
            issued_uuid: responseData.issued_document_id || prev.issued_uuid,
            document_name: responseData.document_name || prev.document_name,
            doc_data: responseData.doc_fields || {},
          }))
        }

        const validateSecureQr = async (verificationToken) => {
          if (!verificationToken) {
            return
          }

          setLoading(true)
          try {
            const res = await API.post(VALIDATE_SECURE_QR, { code_content: verificationToken })
            const responseData = res.data.data || {}
            if (responseData.payment_required) {
              localStorage.removeItem(VERIFICATION_RESULT_STORAGE_KEY)
              cogoToast.info("Payment required to view verification details.")
              navigate(responseData.redirect_to || "/dashboard/cart")
              return
            }
            if (res.data.status == 200) {
              hydrateFromValidationResponse(responseData)
              localStorage.setItem(VERIFICATION_RESULT_STORAGE_KEY, JSON.stringify(responseData))
              navigate(`/dashboard/emp/requestDetails/${res.data.data.shared_data_id}/null/${res.data.data.verification_request_id}`)
            }
          } catch (err) {
            const errorMessage = err?.response?.data?.detail || "Unable to validate secure QR"
            localStorage.removeItem(VERIFICATION_RESULT_STORAGE_KEY)
            cogoToast.error(errorMessage)
            setTimeout(()=>{
              navigate("/dashboard")
            },100)
          } finally {
            setLoading(false)
            localStorage.removeItem("doc_token")
          }
        }

        useEffect(() => {
          const verificationToken = localStorage.getItem("doc_token")
          if (verificationToken) {
            validateSecureQr(verificationToken)
            return
          }

          const cachedResult = localStorage.getItem(VERIFICATION_RESULT_STORAGE_KEY)
          if (!cachedResult) {
            return
          }

          try {
            const parsedResult = JSON.parse(cachedResult)
            hydrateFromValidationResponse(parsedResult)
          } catch (error) {
            localStorage.removeItem(VERIFICATION_RESULT_STORAGE_KEY)
          }
        }, [])

        const getPdf = () => {
          const currentIssuedUuid = documentDetails?.issued_uuid || issued_uuid
          if (!currentIssuedUuid) {
            cogoToast.error("Issued document id not found")
            return
          }

          setPDFloading(true)
          API.get(DOCUMENT_PREVIEW + currentIssuedUuid)
            .then(response => {
              setPDFloading(null)
              setPreview(response.data.data.pdf);
            }).catch(err => {
              setPDFloading(null);
              setPreview(null)
              setLoadingText("Error while generating PDF");
            })
        }
        const DocPreview = () => {
          var loading = {
            padding: "1rem",
            height: "10vh",
            width: "-webkit-fill-available",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }
          if (!preview) {
            return (<div style={loading}>
              {loadingText}
            </div>)
          }
          else {
            return (
              <embed
                id="pdf-viewer"
                src={preview + "#toolbar=0"}
                type="application/pdf"
              />
            )
          }
        }
  return (
        <div style={{width:"100%"}}>
        <SlideUpWrapper>
        {/* <div className={style.documentBox}>
          <div>
            <div className={style.documentHeader}>
              <div>
              <Icon icon={androidArrowBack} size={'1.2rem'} onClick={() => navigate("/dashboard")} style={{ cursor: 'pointer', paddingRight:"7px" }} />
              </div>
              <div>
              <Icon icon={fileText} size={30} />
              </div>
              <div>
                <h2>{documentDetails?.document_name}</h2>
              </div>
              {pdfLoading?
              <ShimmerLoader width='2.3rem' height='2.3rem' mt='.2rem' />:
              <div className='eye-icon' onClick={e => getPdf()} title=" View Document">
                   <img alt="" src="/eyeoutline.svg" />
                </div>}
            </div>
            <div style={{margin:"15px 0px"}}>
            <div className="credentials-table">
                <table style={{ border:"1px solid lightgray",borderRadius: "10px" }}>
                  <tr className="credentials-header bg-lgray">
                  <th className="credentials-th" style={{justifyContent:"start"}}>
                      <div className="credentials-table-text" style={{fontSize:"18px"}}>User Details</div>
                    </th>
                  </tr>
                  {loading ? <>
                    <tr className="credentials-tr" >
                      <td className="credentials-td">
                        <div className="credentials-table-text"><ShimmerLoader width='15rem' height='1.5rem' /></div>
                      </td>
                      <td className="credentials-td">
                        <div className="credentials-table-text"><ShimmerLoader width='15rem' height='1.5rem' /></div>
                      </td>
                    </tr>
                    </>
                    :
                    <>
                    <tr className='credentials-tr'>
                      <td className='credentials-td' style={{justifyContent:"start"}}>
                        <div className='credentials-table-text' style={{fontSize:"16px",}}>Document Id</div>
                      </td>
                      <td className='credentials-td' style={{justifyContent:"start"}}>
                        <div className='credentials-table-text' style={{fontSize:"16px"}}>{documentDetails?.issued_uuid}</div>
                      </td>
                    </tr>
                    <tr className='credentials-tr'>
                      <td className='credentials-td' style={{justifyContent:"start"}}>
                        <div className='credentials-table-text' style={{fontSize:"16px"}}>Company Name</div>
                      </td>
                      <td className='credentials-td' style={{justifyContent:"start"}}>
                        <div className='credentials-table-text' style={{fontSize:"16px"}}>{documentDetails?.issuer_name}</div>
                      </td>
                    </tr>
                    <tr className='credentials-tr'>
                    <td className='credentials-td' style={{justifyContent:"start"}}>
                        <div className='credentials-table-text' style={{fontSize:"16px"}}>Name</div>
                      </td>
                      <td className='credentials-td' style={{justifyContent:"start"}}>
                        <div className='credentials-table-text' style={{fontSize:"16px"}}>{documentDetails?.candidate_name}</div>
                      </td>
                    </tr>
                    </>
                    }
                  </table>
            </div>
    
            </div>
            <div>
            <div className="credentials-table">
                <table style={{ border:"1px solid lightgray",borderRadius: "10px" }}>
                  <tr className="credentials-header bg-lgray">
                  <th className="credentials-th" style={{justifyContent:"start"}}>
                      <div className="credentials-table-text" style={{fontSize:"18px"}}>Issued document fields</div>
                    </th>
                  </tr>
                  {loading ? <>
                    <tr className="credentials-tr" >
                      <td className="credentials-td">
                        <div className="credentials-table-text"><ShimmerLoader width='15rem' height='1.5rem' /></div>
                      </td>
                      <td className="credentials-td">
                        <div className="credentials-table-text"><ShimmerLoader width='15rem' height='1.5rem' /></div>
                      </td>
                    </tr>
                    </>
                    :
                    <>
                    {documentDetails?.doc_data && Object.entries(documentDetails?.doc_data).map(([key, value])=>(
                    <tr className='credentials-tr'>
                      <td className='credentials-td' style={{justifyContent:"start"}}>
                        <div className='credentials-table-text' style={{fontSize:"16px"}}>{formatText(key)}</div>
                      </td>
                      <td className='credentials-td' style={{justifyContent:"start"}}>
                        <div className='credentials-table-text' style={{fontSize:"16px"}}>{value}</div>
                      </td>
                    </tr>))}
                    </>
                    }
                  </table>
            </div>
    
            </div>
          </div>
           <ReactPortalModal title="Published Document" isOpen={preview} onClose={e => setPreview(null)}>
                    <DocPreview />
                  </ReactPortalModal>
        </div> */}
        <AnimatedLoader loadingText={"Please wait..."} isOpen={loading}/>
        </SlideUpWrapper>
        </div>
  )
}

export default QryptalData